import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { CropperImageComponent } from 'src/app/components/bloques/cropper-image/cropper-image.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { ApiSalesService } from 'src/app/services/api-sales.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContactPanelComponent } from '../../contact-panel/contact-panel.component';
import { UpdateBusinessComponent } from '../update-business/update-business.component';

@Component({
  selector: 'app-info-business',
  templateUrl: './info-business.component.html',
  styleUrls: ['./info-business.component.scss']
})
export class InfoBusinessComponent {

  @Input() business: any;
  @Input() idBusiness: any;
  @Input() owner!: any;
  @Input() description!: any;
  user!: any;
  urlImages: string = AppSettings.MEDIA_URI + '/';
  imgControl: FormControl = new FormControl(null);
  changedImg: boolean = false;
  profile = this.auth.getProfile();
  rolesProfile: any[] = this.profile?.roles.map((role: any) => role.name);
  admin: boolean = false;
  allChannels: any[] = [];


  constructor(private dialog: MatDialog, private auth: AuthenticationService, private businessService: ApiBusinessService, private apiSalesService: ApiSalesService) { }

  ngOnInit(): void {
    this.rolesProfile.forEach(element => {
      if (element == 'admin' || element == 'superadmin' || element == 'ACCESS_CLOUD' || element == 'ACCOUNT_OWNER' || element == 'ACCESS_EXTERN_EVENTS' || element == 'ACCESS_ADMIN' || element == 'ACCESS_MANAGER') {
        this.admin = true;
        return;
      }
    });
    this.apiSalesService.getAllMethods().subscribe({
      next: (res) => { this.allChannels = res?.data || []; }
    });
  }

  isChannelActive(channel: any): boolean {
    const active = this.business?.tpv_info?.sales_channel || [];
    return active.some((sc: any) => sc.id === channel.id || sc.name === channel.name);
  }

  ngAfterViewInit() {
    this.user = this.auth.getProfile();
  }

  /** Devuelve el valor de comisión con IVA del 21% incluido */
  withVat(value: number): number {
    return value * 1.21;
  }

  ngOnChanges() {
    if (this.business?.image_url) {
      const imageUrl = this.getImageUrl(this.business.image_url);
      this.imgControl.setValue(imageUrl);
    }
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      // Validar que sea una imagen
      if (!file.type.match('image.*')) {
        this.openInfoCard('Solo se permite utilizar imágenes', false, true);
        event.target.value = '';
        return;
      }

      // Validar tamaño máximo de 10 MB (10485760 bytes)
      const maxSize = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxSize) {
        this.openInfoCard('La imagen no puede ocupar <br> más de 10 MB.', false, true);
        event.target.value = '';
        return;
      }

      const dialogRef = this.dialog.open(CropperImageComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: event
      });

      dialogRef.afterClosed().subscribe((result) => {
        event.target.value = '';
        if (result) {
          this.imgControl.setValue(result.pathUrl);
          this.changedImg = true;
          // Guardar la imagen recortada
          this.businessService.setBusinessSimpleInfo(this.idBusiness, {file: result.object.base64}).subscribe({
            next: (res) => {
              if (res) {
                // Actualizar el business object con la nueva imagen
                if (res.data && res.data.image_url) {
                  this.business.image_url = res.data.image_url;
                  const imageUrl = this.getImageUrl(res.data.image_url);
                  this.imgControl.setValue(imageUrl);
                }
                this.openInfoCard('La imagen se ha actualizado correctamente', false, false);
                this.changedImg = false;
              }
            },
            error: (err) => {
              this.openInfoCard('¡Vaya! Ha ocurrido un error al intentar actualizar la imagen', true, false);
              if (this.business.image_url) {
                const imageUrl = this.getImageUrl(this.business.image_url);
                this.imgControl.setValue(imageUrl);
              }
            }
          });
        }
      });
    }
    if (!event.target.files) {
      if (this.business.image_url) {
        const imageUrl = this.getImageUrl(this.business.image_url);
        this.imgControl.setValue(imageUrl);
      }
    }
  }

  saveImage() {
    this.businessService.setBusinessSimpleInfo(this.idBusiness, {file: this.imgControl.value}).subscribe({
      next: (res) => {
        if (res) {
          this.openInfoCard('La imagen se ha actualizado correctamente', false, false);
          this.changedImg = false;
        }
      }, error: (err) => {
        this.openInfoCard('¡Vaya! Ha ocurrido un error al intentar actualizar la imagen', true, false);
      }
    })
  }

  openInfoCard(msg: string, disabledClose: boolean = false, icon: boolean = true) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false
      }
    });
  }

  openUpdateBusiness(valueToChange: any, nameValue: string) {
    if (valueToChange === 'slug') {
      this.confirmSlugEdit().then((confirmed) => {
        if (confirmed) {
          this.openUpdateBusinessDialog(valueToChange, nameValue);
        }
      });
      return;
    }

    this.openUpdateBusinessDialog(valueToChange, nameValue);
  }

  private confirmSlugEdit(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: {
          icon: true,
          text: '¿Estás seguro de que quieres cambiar la URL personalizada de la organización? Los enlaces que se hayan compartido con la URL ya no serán válidos.',
          btnCancel: true,
          textButton: 'Sí',
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        resolve(!!result);
      });
    });
  }

  private openUpdateBusinessDialog(valueToChange: any, nameValue: string) {
    const dialogRef = this.dialog.open(UpdateBusinessComponent, {
      panelClass: 'info-dialog',
      data: {
        id: this.idBusiness,
        valueChange: valueToChange,
        name: nameValue,
        value: this.business,
        description: this.description
      }
    })
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.status == 'changed') {
          // this.business.name = res.value.name;
          this.business.general_conditions = res.value.general_conditions;
          this.business.address = res.value.address;
          this.business.city = res.value.city;
          this.business.country = res.value.country;
          this.business.postal_code = res.value.postal_code;
          this.business.state = res.value.state;
          this.business.name = res.value.name;
          this.business.slug = res.value.slug;
          this.description = res.value.description;
          this.openInfoCard('Los cambios se han guardado correctamente', false, false);
        }
        if (res?.status == 'error') {
          let msg = res.msg ? res.msg : '¡Vaya! Ha ocurrido un error, vuelve a intentarlo más tarde.';
          this.openInfoCard(msg);
        }
      }
    })
  }

  openContactBusiness() {
    const dialogRef = this.dialog.open(ContactPanelComponent, {
      panelClass: 'info-dialog',
      data: {
        email: this.user.email
      }
    })
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.code == '200') {
          this.openInfoCard('Gracias por contactar con nosotros. En un plazo máximo de 48 horas recibirás una respuesta.', false, false);
        }
        if (res == 'error') {
          this.openInfoCard('¡Vaya! No se ha podido mandar el mensaje. Por favor, inténtalo de nuevo más tarde.');
        }
      }
    })
  }

  getImageUrl(imageUrl: string): string {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }

    // Remover slash inicial si existe y prepend companies_images/
    let processedUrl = imageUrl.startsWith('/') ? imageUrl.substring(1) : imageUrl;
    processedUrl = '/companies_images/' + processedUrl;

    // Evitar doble slash
    return this.urlImages + processedUrl;
  }

  getOnlinePaymentMethod(): string {
    const paymentTypes = this.business?.tpv_info?.payment_types || [];

    // Buscar Paylands primero
    const paylands = paymentTypes.find((p: any) =>
      p.name.toLowerCase().includes('paylands')
    );

    if (paylands) {
      return 'Paylands';
    }

    // Si no existe Paylands, buscar Redsys
    const redsys = paymentTypes.find((p: any) =>
      p.name.toLowerCase().includes('redsys')
    );

    return redsys ? 'Redsys' : '';
  }

  /**
   * Grupos de canales de venta para mostrar en la UI:
   * - Web     = canal "Online"
   * - Taquilla = canales "TPV" y/o "Efectivo"
   * - Totem   = canal "Totem"
   */
  get groupedChannels(): { label: string; detail?: string; active: boolean }[] {
    const active: any[] = this.business?.tpv_info?.sales_channel || [];
    const hasChannel = (...names: string[]) =>
      names.some(n => active.some((sc: any) => sc.name?.toLowerCase() === n.toLowerCase()));

    const paymentMethod = this.getOnlinePaymentMethod();

    return [
      {
        label: 'Web',
        detail: hasChannel('Online') && paymentMethod ? paymentMethod : undefined,
        active: hasChannel('Online'),
      },
      {
        label: 'Taquilla',
        active: hasChannel('TPV', 'Efectivo'),
      },
      {
        label: 'Totem',
        active: hasChannel('Totem'),
      },
    ];
  }

  getBusinessPublicUrl(): string {
    const businessSlug = (this.business?.slug || '').trim();
    return `${window.location.origin}/events/${businessSlug}`;
  }

  copyBusinessUrl(): void {
    navigator.clipboard.writeText(this.getBusinessPublicUrl());
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: '¡Enlace copiado al portapapeles!',
        btnCancel: false
      }
    });
  }
}
